module.exports = __webpack_public_path__ + "static/media/Leichte Sprache.a5ba2f99.pdf";